import { render, staticRenderFns } from "./profile-patient.vue?vue&type=template&id=5819c5ff&scoped=true"
import script from "./profile-patient.vue?vue&type=script&lang=js"
export * from "./profile-patient.vue?vue&type=script&lang=js"
import style0 from "./profile-patient.vue?vue&type=style&index=0&id=5819c5ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819c5ff",
  null
  
)

export default component.exports